import React, { useContext } from "react";
import Report from "views/Statistics/Report/Hourly/component";
import ActionsContext from "common/ActionsContext";
import { parsePoliciesFlows, policiesFlowsRetrieval } from "../api";
import View from "common/View";
import help from "help/viewFlowsPerPolicy.md";


const retrieval = ({ hours, type, mode, bqnId }) =>
  policiesFlowsRetrieval({ hours, type, mode, bqnId })
    .then(parsePoliciesFlows)
    .catch((error) => console.error(error) || error);

const enabled = {
  hours: true,
  directions: false,
  categories: false,
  target: false,
  output: false,
  filter: false,
};

const FlowsPerLPolicyHourly = () => {
  const actions = useContext(ActionsContext);
  return (
    <View title="Flows per policy over time" mdHelp={help}>
      <Report
        from="timeline"
        itemsFrom="policies"
        itemsValueFrom="flows"
        yAxisUnits="Flows"
        yAxisPrecision={0}
        provider={retrieval}
        actions={actions}
        enabled={enabled}
      />
    </View>
  );
};

export default FlowsPerLPolicyHourly;
